import { render, staticRenderFns } from "./ClientSettingFixedPhrase.vue?vue&type=template&id=bed0d986&scoped=true"
import script from "./ClientSettingFixedPhrase.vue?vue&type=script&lang=js"
export * from "./ClientSettingFixedPhrase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed0d986",
  null
  
)

export default component.exports